import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Clients',
      value: stats?.totalClients,
      change: '+12%',
      changeType: 'positive',
      icon: 'Users',
      color: 'bg-primary/10 text-primary'
    },
    {
      title: 'Active Leads',
      value: stats?.activeLeads,
      change: '+8%',
      changeType: 'positive',
      icon: 'TrendingUp',
      color: 'bg-accent/10 text-accent'
    },
    {
      title: 'Under Contract',
      value: stats?.underContract,
      change: '+15%',
      changeType: 'positive',
      icon: 'FileText',
      color: 'bg-warning/10 text-warning'
    },
    {
      title: 'Closed This Month',
      value: stats?.closedThisMonth,
      change: '+22%',
      changeType: 'positive',
      icon: 'CheckCircle',
      color: 'bg-success/10 text-success'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-xl p-6 elevation-1 transition-smooth hover:elevation-2 hover:border-border/80">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${stat?.color}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <span className={`text-sm font-medium ${
              stat?.changeType === 'positive' ? 'text-success' : 'text-error'
            }`}>
              {stat?.change}
            </span>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">{stat?.value}</h3>
            <p className="text-sm text-muted-foreground">{stat?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientStats;